import sys from '@truckdown/jsclient';
import * as apis from '@truckdown/jsclient/apis';
import { defineComponent, ref } from 'vue';

export default defineComponent({
    props: {
        isBackgroundLight: Boolean,
        moreInfoUrl: String
    },
    setup: function (props, ctx) {
        let isAuth = sys.framework.context.isAuthenticated();
        let isAce = sys.framework.context.isInRole(apis.framework.SecurityConstants.Roles.FleetUserRole);

        let backgroundLight = props.isBackgroundLight as boolean || false;

        const getUrl = function (path: string) {
            let currentUrl = window.location.pathname + window.location.search + window.location.hash;
            return path + '?returnUrl=' + encodeURIComponent(currentUrl);
        }

        const register = function (ev: Event) {

        }

        const upgrade = function (ev: Event) {

        }

        return {
            isAuth,
            isAce,
            register,
            upgrade,
            backgroundLight,
            getUrl
        };
    }
});
